import { BaseEnum } from "services/enums/baseEnum";

const listsEnum: Array<FormInputType> = [];

export class FormInputType extends BaseEnum {
  static SELECT = new FormInputType(
    2,
    "SELECT",
    "Caixa de seleção",
    "list",
    "Campo para seleção de uma opção em uma lista suspensa."
  );
  static MULTISELECT = new FormInputType(
    3,
    "MULTISELECT",
    "Caixa de seleção múltipla",
    "list",
    "Campo para seleção de várias opções entre várias em uma lista suspensa."
  );

  static TEXTAREA = new FormInputType(
    4,
    "TEXTAREA",
    "Resposta longa",
    "align-justify",
    "Campo para respostas longas em texto livre."
  );
  static TEXT = new FormInputType(
    5,
    "TEXT",
    "Resposta curta",
    "align-left",
    "Campo para respostas curtas em texto livre."
  );

  static DATE = new FormInputType(
    6,
    "DATE",
    "Data",
    "calendar",
    "Campo para seleção de data."
  );

  static RADIO_OPTION = new FormInputType(
    1,
    "RADIO_OPTION",
    "Seleção simples",
    "disc",
    "Campo para seleção de uma única opção entre várias."
  );
  static RADIO_OPTION_MULTISELECT = new FormInputType(
    8,
    "RADIO_OPTION_MULTISELECT",
    "Seleção múltipla",
    "check-square",
    "Campo para seleção de várias opções entre várias."
  );
  static RADIO_OPTION_GRID = new FormInputType(
    9,
    "RADIO_OPTION_GRID",
    "Grade de seleção simples",
    "grid",
    "Tabela para selecionar uma única opção por linha."
  );
  static RADIO_OPTION_MULTISELECT_GRID = new FormInputType(
    10,
    "RADIO_OPTION_MULTISELECT_GRID",
    "Grade de seleção múltipla",
    "grid",
    "Tabela para selecionar uma ou mais opções por linha."
  );
  static NPS = new FormInputType(
    12,
    "NPS",
    "NPS",
    "smile",
    "Campo fixo de 0 a 10 para medir recomendação com padrão Net Promoter Score."
  );
  static TRUE_OR_FALSE = new FormInputType(
    7,
    "TRUE_OR_FALSE",
    "Seleção verdadeira ou falsa",
    "check-circle",
    "Campo para seleção de verdadeiro ou falso."
  );

  static NUMERIC_SCALE = new FormInputType(
    11,
    "NUMERIC_SCALE",
    "Escala numérica",
    "sliders",
    "Campo para escolha de um valor numérico dentro de uma escala definida."
  );

  constructor(
    public id: number,
    public value: string,
    public label: string,
    public icon: string,
    public description: string
  ) {
    super(id, value, label, icon);
    listsEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listsEnum;
  }
}
